<script setup lang="ts">
import { computed } from 'vue';
import { RBCCellTypeStats } from '@/types/rbc';
import { getStatusTheme } from '@/utils/progressUtils';

const props = defineProps<{
  progress: number;
  status: RBCCellTypeStats["status"];
}>();

const theme = computed(() => getStatusTheme(props.progress, props.status));
const colorClass = computed(() => theme.value.colorClass);
</script>

<template>
  <div class="progress-container">
    <div
      class="progress shadow-sm"
      style="height: 10px; width: 120px;"
    >
      <div 
        class="progress-bar rounded-pill transition-all" 
        :class="colorClass"
        role="progressbar" 
        :style="{ width: `${progress}%` }" 
        :aria-valuenow="progress" 
        aria-valuemin="0" 
        aria-valuemax="100"
      />
    </div>
    <span
      class="ms-2 fw-bold text-muted"
      style="min-width: 40px;"
    >{{ progress }}%</span>
  </div>
</template>

<style scoped>
.progress-container {
  display: flex;
  align-items: center;
}
.transition-all {
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.progress {
  background-color: #f1f5f9;
  overflow: hidden;
}
.status-danger {
  background-color: #ef4444;
}
.status-warning {
  background-color: #f59e0b;
}
.status-success {
  background-color: #10b981;
}
</style>
